import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { examDisplayNames } from '@app-constants/app.constants';
import { TenantConstant } from '@app-constants/tenant.constant';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hall-ticket-dialog',
  templateUrl: './hall-ticket-dialog.component.html',
  styleUrls: ['./hall-ticket-dialog.component.css']
})
export class HallTicketDialogComponent implements OnInit {
  tenant:any = TenantConstant.tenant;
  visitLink: any;
  hallTicket: any = '';
  invalidInput: boolean = false;
  public examName: any;
  displayedExamName: any = '';
  constructor(private activeModal: NgbActiveModal, private router:Router, private testListService: TestlistService, private userService: UserService) { 
  }

  ngOnInit(): void {
    console.log("hall ticket dialog");
    this.visitLink = this.tenant=='srichaitanya' ? 'https://srichaitanya.infinitylearn.com/spl-testseries': 'https://infinitylearn.com/spl-testseries';
    this.examName = this.examName || 'NEET';
    this.displayedExamName = examDisplayNames[this.examName] || "NEET";
  }

  visit() {
    window.open(this.visitLink, '_blank');
  }
  
  Submit() {
    this.invalidInput = false;
    if(!(/([0-9]|[a-z])+/i.test(this.hallTicket))) {
      this.invalidInput = true;
    } else {
      const detail = this.userService.getMobileAndName()
      let studentid = this.tenant=='srichaitanya' ? localStorage.getItem('studentid'): detail?.isdCode + " " + localStorage.getItem('studentid')

      const body = {
        tenantid: this.tenant,
        studentid,
        examname: this.examName,
        examyear: "2021",
        hallticket: this.hallTicket
      };
      this.testListService.savestudenthalltickets(body).subscribe(() => {});
      this.Close(); 
    }
   }

  Close() {
   this.activeModal.close(); 
  }
}
